/**
 * 主要用于存储一些首页营销、圈客状态的首页，不需要持久化保存，但是需要在应用状态中维持，用来优化用户访问体验
*/
import RootStateType from '@/store/types';
import { ActionContext, Module } from 'vuex';
import store from '@/store';
import generateMutations, { UPDATE_STATE_TYPE } from '@/store/generate-mutations';
import { HomeSummaryResponse } from '@/api/rights/shop-mall/types';
import { queryHomeSummary } from '@/api/rights/shop-mall';
import { ubtSendError } from '@/shared/utils/ubt';
import {
  HomeMarketStoreStateType,
} from './types';

let currentRequest: Promise<void> | null = null;

const moduleStore: Module<HomeMarketStoreStateType, RootStateType> = {
  namespaced: true,
  state: {
    installMallShow: false,
    installMallInfo: null,
  },
  actions: {

    // 修改后的 queryHomeInstallMallSummary 方法
    async queryHomeInstallMallSummary(
      context: ActionContext<HomeMarketStoreStateType, RootStateType>,
    ) {
      // 复用进行中的请求
      if (currentRequest) {
        return currentRequest;
      }

      // 创建新请求并存储
      currentRequest = (async () => {
        try {
          const response: HomeSummaryResponse | undefined = await queryHomeSummary();
          if (response?.jumpUrl) {
            context.dispatch(UPDATE_STATE_TYPE, {
              installMallShow: true,
              installMallInfo: response,
            });
          } else {
            context.dispatch(UPDATE_STATE_TYPE, {
              installMallShow: false,
            });
          }
        } catch (error) {
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          ubtSendError(`get entrance url home error${error}`);
        } finally {
          // 关键：请求完成后重置单例标识
          currentRequest = null;
        }
      })();

      return currentRequest;
    },
  },
};

store.registerModule(
  'homeMarketStore',
  generateMutations<HomeMarketStoreStateType>(moduleStore),
);
